export default function englishCondition(lang: string, visiteur?:boolean ):boolean {
    return lang === "en" && visiteur === true
}
